import { FormErrors } from 'redux-form';

export interface BatteryFormData {
  // Step 1
  main_tank?: string;
  full_address?: string;
  address?: string;
  zip?: string;
  locality?: string;
  state?: string;
  country_iso2?: string;
  lat?: number;
  lon?: number;
  plumbing?: string;
  connection_kit?: string;
  electrical?: string;
  free_methven?: string;
  provide_stc?: string;
  pickup_sitedelivery?: string;
  add_extras?: string;
  how_many?: string;
  subsidies?: string;
  // Step 2
  choice_type_install?: string;
  hot_cold_connections?: string;
  located_within?: string;
  additional_untempered?: string;
  concrete_pavers_tank?: string;
  concrete_pavers_heatpump?: string;
  quote_showerhead?: string;
  connected_to_reticulated_gas?: string;
  bca_building?: string;
  sa_reps_rebate?: string;
  is_your_replacement_urgent?: string;
  choice_type_product?: string;
  product_choice_type?: string;
  product_choice?: string;
  formchoice_extra?: string;
  electric_storage_located?: string;
  where_about_inside?: string;
  where_about_outside?: string;
  on_ground_adjacent?: string;
  compressor_unit?: string;
  solar_boosted?: string;
  new_place_choice?: string;
  existing_install_location?: string;
  install_location_access?: string;
  stair_access?: string;
  electrical_already?: string;
  drain_nearby?: string;
  hot_water_rebate?: string;
  exist_hws_gt_3yr?: string;
  indicative_pricing?: string;
  pe_note?: string;
  // Step 3
  note_select?: string;
  customer_note?: string;
  your_email?: string;
  info_pack?: string;
  phone_number?: string;
  first_name?: string;
  last_name?: string;
  scope_pdf?: string;
  system_owner_entity_type?: string;
  prepared_by?: string;
  hear_about?: string;
  send_sms?: string;
  sms_template?: string;
  summary?: string;
}

export const validate = (values: BatteryFormData) => {
  let errors: FormErrors<BatteryFormData> = {};

  errors.main_tank = validator(['required'], values.main_tank);
  errors.full_address = validator(['required'], values.full_address);
  errors.plumbing = validator(['required'], values.plumbing);
  errors.connection_kit = validator(['required'], values.connection_kit);
  errors.electrical = validator(['required'], values.electrical);
  errors.free_methven = validator(['required'], values.free_methven);
  errors.provide_stc = validator(['required'], values.provide_stc);
  errors.pickup_sitedelivery = validator(['required'], values.pickup_sitedelivery);
  errors.add_extras = validator(['required'], values.add_extras);
  errors.how_many = validator(['required'], values.how_many);

  errors.choice_type_install = validator(['required'], values.choice_type_install);
  errors.hot_cold_connections = validator(['required'], values.hot_cold_connections);
  errors.located_within = validator(['required'], values.located_within);
  errors.additional_untempered = validator(['required'], values.additional_untempered);
  errors.concrete_pavers_tank = validator(['required'], values.concrete_pavers_tank);
  errors.concrete_pavers_heatpump = validator(['required'], values.concrete_pavers_heatpump);
  errors.quote_showerhead = validator(['required'], values.quote_showerhead);
  errors.connected_to_reticulated_gas = validator(['required'], values.connected_to_reticulated_gas);
  errors.bca_building = validator(['required'], values.bca_building);
  errors.sa_reps_rebate = validator(['required'], values.sa_reps_rebate);
  errors.is_your_replacement_urgent = validator(['required'], values.is_your_replacement_urgent);
  errors.choice_type_product = validator(['required'], values.choice_type_product);
  errors.product_choice_type = validator(['required'], values.product_choice_type);
  errors.product_choice = validator(['required'], values.product_choice);
  errors.formchoice_extra = validator(['required'], values.formchoice_extra);
  errors.electric_storage_located = validator(['required'], values.electric_storage_located);
  errors.where_about_inside = validator(['required'], values.where_about_inside);
  errors.where_about_outside = validator(['required'], values.where_about_outside);
  errors.on_ground_adjacent = validator(['required'], values.on_ground_adjacent);
  errors.compressor_unit = validator(['required'], values.compressor_unit);
  errors.solar_boosted = validator(['required'], values.solar_boosted);
  errors.new_place_choice = validator(['required'], values.new_place_choice);
  errors.existing_install_location = validator(['required'], values.existing_install_location);
  errors.install_location_access = validator(['required'], values.install_location_access);
  errors.stair_access = validator(['required'], values.stair_access);
  errors.electrical_already = validator(['required'], values.electrical_already);
  errors.drain_nearby = validator(['required'], values.drain_nearby);
  errors.hot_water_rebate = validator(['required'], values.hot_water_rebate);
  errors.exist_hws_gt_3yr = validator(['required'], values.exist_hws_gt_3yr);
  errors.indicative_pricing = validator(['required'], values.indicative_pricing);

  //step 3
  errors.note_select = validator(['required'], values.note_select);
  errors.your_email = validator(['required', 'validate_email'], values.your_email);
  errors.info_pack = validator(['required'], values.info_pack);
  errors.first_name = validator(['required'], values.first_name);
  errors.last_name = validator(['required'], values.last_name);
  errors.phone_number = validator(['required', 'validate_phone_number'], values.phone_number);
  // errors.scope_pdf = validator(['required'], values.scope_pdf);
  // errors.system_owner_entity_type = validator(['required'], values.system_owner_entity_type);
  errors.prepared_by = validator(['required'], values.prepared_by);
  errors.hear_about = validator(['required'], values.hear_about);
  errors.send_sms = validator(['required'], values.send_sms);
  errors.sms_template = validator(['required'], values.sms_template);
  return errors;
}

const validator = (attrs: string[], value: any) => {
  let errorTxt = '';
  attrs.forEach((item: string) => {
    switch (item) {
      case 'required':
        if (!value) errorTxt = 'This field is required '
        break;
      case 'validate_email':
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
          errorTxt = 'Invalid email address '
        }
        break;
      case 'validate_phone_number':
        if (!/\(?([0-9]{4})\)?([ .-]?)([0-9]{3})\2([0-9]{3})/i.test(value)) errorTxt = "Invalid phone number"
        break;
      default:
        break;
    }
  });
  return errorTxt;
}